export default __webpack_public_path__ + "static/gitops-explore-design-f810646181a4b9886bd5d3f4fc346d9e.webp";